import { Box, Typography } from '@mui/material';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { ColorPicker } from '../../config/ColorPicker';
import { sxConfig } from './EmployeeActivity.style';

const EmployeeActivityChip = ({ data }) => {
  const [elapsedTime, setElapsedTime] = useState(null);
  const [timer, setTimer] = useState(null);

  const chipBg = ColorPicker.find((color) => color.colorName === data?.productionStatus?.color);
  const startedOperation = data?.productionReport?.find((report) => report.startDate && !report.endDate);

  const lastUserReport = data.productionReport?.[data.productionReport.length - 1];

  useEffect(() => {
    if (startedOperation?.startDate) {
      if (timer) {
        clearInterval(timer);
      }

      const interval = setInterval(() => {
        const start = dayjs(startedOperation.startDate);
        const now = dayjs();
        const diff = dayjs.duration(now.diff(start));

        setElapsedTime(
          `${diff.hours().toString().padStart(2, '0')}:${diff.minutes().toString().padStart(2, '0')}:${diff.seconds().toString().padStart(2, '0')}`
        );
      }, 1000);

      setTimer(interval);

      return () => clearInterval(interval);
    } else {
      if (timer) {
        clearInterval(timer);
        setTimer(null);
      }
      setElapsedTime(null);
    }
  }, [startedOperation]);

  return (
    <Box sx={sxConfig(chipBg).chipContainerBox}>
      <Typography>
        {data.isMultiResource && <PeopleAltIcon sx={sxConfig().chipPeopleIcon} />}
        {data.label}
        {elapsedTime && ` (${elapsedTime})`}
      </Typography>

      {startedOperation?.downtimeCode && (
        <Typography sx={sxConfig().chipTypography}>Állás oka: {startedOperation.downtimeReason?.name}</Typography>
      )}

      {!!lastUserReport?.interruptionCode && (
        <Typography sx={sxConfig().chipTypography}>
          Megszakítás oka: {lastUserReport.interruptionReason?.name}
        </Typography>
      )}
    </Box>
  );
};

export default EmployeeActivityChip;
